import { useState } from "react";
import { Link } from "react-router-dom";
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCol,
  MDBContainer,
  MDBInput,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
} from "mdb-react-ui-kit";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import Constantes from "Projects/CC_cubi_clan_project/Utils/Constantes";

function detectAppCode() {
  const hostname = window.location.hostname;
  if (Constantes.TEAN_ORIGINS.includes(hostname)) return "TEAN";
  if (Constantes.MUGIN_ORIGINS.includes(hostname)) return "MUGIN";
  if (Constantes.HAPK_ORIGINS.includes(hostname)) return "HAPK";
  return "SSO";
}

export default function ForgotPasswordView() {
  const [email, setEmail] = useState("");
  const appCode = detectAppCode();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [debugUrl, setDebugUrl] = useState("");

  const submitRequest = async (event) => {
    event.preventDefault();
    setError("");
    setDebugUrl("");
    setSending(true);

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          appCode,
          frontendBaseUrl: window.location.origin,
        }),
      };

      const response = await doFetch("SSO", "forgotPassword", requestOptions);
      const data = await response.json();

      if (data?.STATE === "SUCCESS") {
        setSent(true);
        if (data?.DATA?.previewResetUrl) {
          setDebugUrl(data.DATA.previewResetUrl);
        }
      } else {
        setError(data?.MESSAGE || "No se pudo procesar la solicitud");
      }
    } catch (fetchError) {
      setError("No se pudo contactar con el servidor");
      console.error(fetchError);
    } finally {
      setSending(false);
    }
  };

  return (
    <MDBContainer className="py-5">
      <MDBRow className="justify-content-center">
        <MDBCol md="8" lg="6" xl="5">
          <MDBCard>
            <MDBCardBody className="p-4">
              <MDBCardTitle className="mb-3">Recuperar contraseña</MDBCardTitle>
              <MDBCardText className="text-muted mb-4">
                Introduce tu email y te enviaremos un enlace para restablecer la contraseña.
              </MDBCardText>

              <MDBValidation noValidate onSubmit={submitRequest}>
                <MDBValidationItem className="mb-3" feedback="Introduce un email válido" invalid>
                  <MDBInput
                    id="forgot-email"
                    type="email"
                    label="Email"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </MDBValidationItem>

                {error ? <div className="alert alert-danger py-2">{error}</div> : null}
                {sent ? <div className="alert alert-success py-2">Si el email existe, recibirás un enlace de recuperación.</div> : null}
                {debugUrl ? (
                  <div className="alert alert-warning py-2">
                    <div className="fw-bold">DEV preview URL:</div>
                    <a href={debugUrl}>{debugUrl}</a>
                  </div>
                ) : null}

                <MDBBtn type="submit" block disabled={sending}>
                  {sending ? "Enviando..." : "Enviar enlace"}
                </MDBBtn>
              </MDBValidation>

              <div className="mt-3 text-center">
                <Link to="/">Volver al login</Link>
              </div>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}
